import React, { useEffect, useState } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { edit_icon, eye_icon, user, view_icon } from "../../../assets/imgs";
import StatusComp from "../../../components/StatusComp";
import { siteListDummy } from "../../redux/api/dummyJson";
import { get, post } from "../../../Services/ApiHandler";
import { URL as API } from "../../../Services/Constant";

const AddCompany = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [logo, setLogo] = useState();
  const [ownerImg, setOwnerImg] = useState();

  const createdAt = moment().format("DD-MM-YYYY");
  const [locList, setLoclist] = useState([]);

  const [formData, setFormData] = useState({
    companyName: "",
    person: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
    siteName: "",
    location: "",
  });

  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);

  const [siteErrors, setSiteErrors] = useState({});

  const [visible, setVisible] = useState(false);
  const [confVisible, setConfVisible] = useState(false);

  const [siteList, setSiteList] = useState([]);

  const type = location?.state?.type;

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const singaporeMobileRegex = /^[89]\d{7}$/;

    if (!formData.companyName.trim())
      newErrors.companyName = "Company Name is required";
    if (!formData.email.trim() || !emailRegex.test(formData.email))
      newErrors.email = "Valid Email is required";
    if (
      !formData.mobile.trim() ||
      !singaporeMobileRegex.test(formData.mobile)
    ) {
      newErrors.mobile = "Enter valid 8-digit Singapore number";
    }
    if (!formData.person.trim()) newErrors.person = "Person Name is required";
    if (!formData.password || formData.password.length < 6)
      newErrors.password = "Password must be at least 6 characters";
    if (formData.confirmPassword !== formData.password)
      newErrors.confirmPassword = "Passwords do not match";
    if (!logo) newErrors.logo = "Company Logo is required";
    if (!ownerImg) newErrors.ownerImg = "Primary Person image is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const siteValidate = () => {
    const newErrors = {};
    if (!formData.siteName.trim()) newErrors.siteName = "Site Name is required";
    if (!formData.location.trim()) newErrors.location = "Loaction is required";
    setSiteErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSiteAdd = () => {
    if (siteValidate(formData.siteName, formData.location)) {
      const newSite = {
        id: Date.now(),
        name: formData.siteName,
        location: formData.location,
        active: true,
        editing: false,
      };
      setSiteList((prev) => [...prev, newSite]);
      setFormData((prev) => ({ ...prev, siteName: "", location: "" }));
    }
  };

  const toggleActive = (id) => {
    setSiteList((prev) =>
      prev.map((site) =>
        site.id === id ? { ...site, active: !site.active } : site
      )
    );
  };

  const handleEdit = (id) => {
    setSiteList((prev) =>
      prev.map((site) =>
        site.id === id ? { ...site, editing: !site.editing } : site
      )
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // clear specific error while typing
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setSiteErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSiteChange = (id, field, value) => {
    setSiteList((prev) =>
      prev.map((site) => (site.id === id ? { ...site, [field]: value } : site))
    );
    // clear site error
    setSiteErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSubmit = () => {
    if (validate()) {
      console.log("Submit successful", formData);
      navigate("/company-list"); // or API call here
    }
  };

  const handleLogoChange = (event) => {
    let image = event.target.files[0];
    if (image) {
      setLogo(image);
      setErrors((prev) => ({
        ...prev,
        logo: "",
      }));
    }
  };
  // console.log('logo', logo)

  const handlePrimaryImg = (event) => {
    let image = event.target.files[0];
    if (image) {
      setOwnerImg(image);
      setErrors((prev) => ({
        ...prev,
        ownerImg: "",
      }));
    }
  };

  const getLocationList = () => {
    get(API.KNF_COMPANY_LOCATION)
      .then((res) => {
        if (res?.status == "success") {
          setLoclist(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getSiteList = (company) => {
    let formdata = new FormData();
    formdata.append("company_id", company);
    post(API.SITE_LIST_ADMIN, formdata)
      .then((res) => {
        // setPagination(res?.pagination_meta);
        setSiteList(res?.lists);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getView = () => {
    get(API.KNF_COMPANY_VIEW + location?.state?.data?.id)
      .then((res) => {
        let data = res?.data;
        if (data?.logo) {
          setLogo(data?.logo);
        }

        let ob = {
          companyName: "",
          person: "",
          email: "",
          mobile: "",
          password: "",
          confirmPassword: "",
          siteName: "",
          location: "",
        };

        if (data?.company_name) {
          ob.companyName = data?.company_name;
        }

        if (data?.knf_user?.name) {
          ob.person = data?.knf_user?.name;
        }

        if (data?.knf_user?.email) {
          ob.email = data?.knf_user?.email;
        }
        if (data?.knf_user?.phone) {
          ob.mobile = data?.knf_user?.phone;
        }
        if (data?.location) {
          ob.location = data?.location;
        }

        setFormData(ob);
        if (data?.knf_user?.profile_image) {
          setOwnerImg(data?.knf_user?.profile_image);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getLocationList();
    if (location?.state?.data?.id) {
      getView();
      getSiteList(location?.state?.data?.id);
    }
  }, []);

  return (
    <div className="dashRightView">
      <StatusComp name={"Company"} type={type} />

      <div className="d-flex flex-wrap gap-5">
        <div className="col-md-5">
          <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
            Company name
          </p>
          <input
            className="input-box"
            name="companyName"
            value={formData.companyName}
            onChange={handleChange}
            type="text"
            placeholder="Company name"
          />
          {errors.companyName && <p className="err">{errors.companyName}</p>}
        </div>
        {type == "add" && (
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Company Logo (size 2 MB)
            </p>
            <input
              className="input-box"
              name="logo"
              onChange={handleLogoChange}
              type="file"
              placeholder="Company Logo"
              accept="image/*"
            />
            {errors.logo && <p className="err">{errors.logo}</p>}
          </div>
        )}

        {type != "add" && (
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Company logo
            </p>
            <img
              src={logo?.name ? URL.createObjectURL(logo) : logo ? logo : user}
              alt=""
              className="user"
            />
            {type != "view" && (
              <>
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  id="edit-logo"
                  onChange={handleLogoChange}
                />

                <button
                  onClick={() => document.getElementById("edit-logo").click()}
                  className="cust-btn"
                >
                  <img src={edit_icon} alt="" className="ms-4 edit-btn" />
                </button>
              </>
            )}
          </div>
        )}

        <div className="col-md-5">
          <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
            Primary person
          </p>
          <input
            className="input-box"
            name="person"
            value={formData.person}
            onChange={handleChange}
            type="text"
            placeholder="Primary person"
          />
          {errors.person && <p className="err">{errors.person}</p>}
        </div>
        {type == "add" && (
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Primary person image (size 2 MB)
            </p>
            <input
              className="input-box"
              name="logo"
              onChange={handlePrimaryImg}
              type="file"
              placeholder="Company Logo"
              accept="image/*"
            />
            {errors.ownerImg && <p className="err">{errors.ownerImg}</p>}
          </div>
        )}

        {type != "add" && (
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Primary person image
            </p>

            <img
              src={
                ownerImg?.name
                  ? URL.createObjectURL(ownerImg)
                  : ownerImg
                  ? ownerImg
                  : user
              }
              alt=""
              className="user"
            />
            {type !== "view" && (
              <>
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  id="edit-logo"
                  onChange={handlePrimaryImg}
                />

                <button
                  onClick={() => document.getElementById("edit-logo").click()}
                  className="cust-btn"
                >
                  <img src={edit_icon} alt="" className="ms-4 edit-btn" />
                </button>
              </>
            )}
          </div>
        )}
        <div className="col-md-5">
          <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
            Primary Email id
          </p>
          <input
            className="input-box"
            name="email"
            value={formData.email}
            onChange={handleChange}
            type="email"
            placeholder="Primary Email id"
          />
          {errors.email && <p className="err">{errors.email}</p>}
        </div>

        <div className="col-md-5">
          <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
            Primary Singapore Mobile number
          </p>
          <input
            name="mobile"
            value={formData.mobile}
            maxLength={8}
            onChange={handleChange}
            className="input-box"
            type="text"
            placeholder="+65 Mobile number"
          />
          {errors.mobile && <p className="err">{errors.mobile}</p>}
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
            Location
          </p>
          <select
            name="location"
            value={formData?.location}
            onChange={handleChange}
            className="input-box"
            type="text"
          >
            <option>Select Location</option>
            {locList?.map((item) => {
              return (
                <option value={item?.id} key={item?.id}>
                  {item?.name}
                </option>
              );
            })}
          </select>
          {errors.location && <p className="err">{errors.location}</p>}
        </div>

        {type !== "view" && (
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Password
            </p>
            <div className="input-box ac-jb ">
              <LockOutlinedIcon className="emial-icon" />
              <input
                name="password"
                value={formData.password}
                onChange={handleChange}
                type={visible ? "text" : "password"}
                maxLength={20}
                placeholder="Password"
              />
              {!visible && (
                <img
                  src={eye_icon}
                  onClick={() => setVisible(!visible)}
                  className="eye-icon pointer mb-1"
                  alt=""
                />
              )}
              {visible && (
                <VisibilityIcon
                  onClick={() => setVisible(!visible)}
                  className="eye-icon "
                />
              )}
            </div>
            {errors.password && <p className="err">{errors.password}</p>}
          </div>
        )}
        {type !== "view" && (
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Confirm Password
            </p>
            <div className="input-box ac-jb">
              <LockOutlinedIcon className="emial-icon" />
              <input
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                type={confVisible ? "text" : "password"}
                maxLength={20}
                placeholder="Confirm Password"
              />
              {!confVisible && (
                <img
                  src={eye_icon}
                  onClick={() => setConfVisible(!confVisible)}
                  className="eye-icon pointer mb-1"
                  alt=""
                />
              )}
              {confVisible && (
                <VisibilityIcon
                  onClick={() => setConfVisible(!confVisible)}
                  className="eye-icon "
                />
              )}
            </div>
            {errors.confirmPassword && (
              <p className="err">{errors.confirmPassword}</p>
            )}
          </div>
        )}
      </div>
      <div className="d-flex ac-js mt-5">
        <button
          onClick={() => navigate(-1)}
          className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
        >
          Back
        </button>

        {type != "view" && (
          <button
            onClick={handleSubmit}
            className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
          >
            {type == "edit" ? "Submit" : "Add"}
          </button>
        )}
      </div>

      <div className="d-flex ac-js mt-2">
        {type == "view" && !show && (
          // <button onClick={() => setShow(true)} className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
          //     Add Site
          // </button>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  mt-4 primary">
            Site List
          </p>
        )}

        {show && (
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mt-4 primary">
            Site List
          </p>
        )}
      </div>

      {type !== "add" && (
        <div className="container mt-4">
          <table className="table table-bordered align-middle">
            <thead className="table-light">
              <tr className="text-center">
                <th>ID</th>
                <th>Site Name & Code</th>
                <th>Site Location</th>
                <th>Site Admin</th>
                <th>Created On</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {siteList?.map((item, ind) => (
                <tr key={ind} className="text-center">
                  <td>{ind + 1}</td>
                  <td>
                    <div>{item?.site_name}</div>
                    <div className="text-muted">{item?.site_code}</div>
                  </td>
                  <td>{item?.site_location}</td>
                  <td>
                    {/* <div>kbf admin</div> */}
                    <div className="text-muted">{item?.user_email}</div>
                    <div className="text-muted">{item?.user_phone}</div>
                  </td>
                  <td>
                    <div className="text-muted">
                      {item?.created_at
                        ? moment(item?.created_at).format("DD-MM-YYYY")
                        : ""}
                    </div>
                  </td>
                  <td className="d-flex ac-jc gap-4">
                    <button
                      onClick={() => {
                        navigate("/sites-view", {
                          state: { type: "view", data: item },
                        });
                      }}
                      className="cust-btn "
                    >
                      <img src={view_icon} alt="" className=" edit-btn " />
                    </button>

                    <button
                      className={`${
                        item?.status ? "active-btn" : "deactive-btn"
                      } w-100 border-0 opacity-50`}
                    >
                      {item?.status ? "Active" : "De-active"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AddCompany;
